 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		6: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"3eb8c39f2ff51f0bcc69d995e828fc48bdc07e16","3":"99cb246920e0191a14a9f169705ee41e2ff61333","4":"6507bc04b12a8d75d910d4fa69105b533fedf2fe","5":"fd05bef4642b45e607f5afa7a046c65a4d4a88aa","8":"component---src-pages-404-js","9":"component---src-pages-about-js","10":"component---src-pages-acquisition-js","11":"component---src-pages-ai-agent-consulting-js","12":"component---src-pages-ai-consulting-js","13":"component---src-pages-ai-studio-js","14":"component---src-pages-analysis-js","15":"component---src-pages-ar-filter-js","16":"component---src-pages-blog-js","17":"component---src-pages-brands-js","18":"component---src-pages-contact-js","19":"component---src-pages-content-marketing-js","20":"component---src-pages-conversion-js","21":"component---src-pages-digital-ads-js","22":"component---src-pages-digital-marketing-consultancy-js","23":"component---src-pages-email-marketing-js","24":"component---src-pages-flatart-lab-js","25":"component---src-pages-geo-js","26":"component---src-pages-index-js","27":"component---src-pages-kariyer-js","28":"component---src-pages-landing-builder-js","29":"component---src-pages-privacy-policy-js","30":"component---src-pages-production-service-js","31":"component---src-pages-search-engine-optimization-js","32":"component---src-pages-services-js","33":"component---src-pages-social-media-js","34":"component---src-pages-start-project-js","35":"component---src-pages-success-stories-arcadium-js","36":"component---src-pages-success-stories-cam-hotel-js","37":"component---src-pages-success-stories-ecanta-js","38":"component---src-pages-success-stories-enerjisa-js","39":"component---src-pages-success-stories-forecr-js","40":"component---src-pages-success-stories-fullamoda-js","41":"component---src-pages-success-stories-index-js","42":"component---src-pages-success-stories-kentpark-js","43":"component---src-pages-success-stories-kuruyemis-borsasi-js","44":"component---src-pages-success-stories-liva-pastacilik-case-study-js","45":"component---src-pages-success-stories-liva-pastacilik-js","46":"component---src-pages-success-stories-matbuu-js","47":"component---src-pages-success-stories-milli-piyango-js","48":"component---src-pages-success-stories-mocaco-js","49":"component---src-pages-success-stories-pakmaya-js","50":"component---src-pages-success-stories-pinduk-js","51":"component---src-pages-success-stories-robesnmore-js","52":"component---src-pages-success-stories-sefa-stone-js","53":"component---src-pages-success-stories-stm-js","54":"component---src-pages-success-stories-tanoto-js","55":"component---src-pages-success-stories-tcdd-tasimacilik-js","56":"component---src-pages-success-stories-toyota-js","57":"component---src-pages-success-stories-un-women-js","58":"component---src-pages-success-stories-villa-yapi-js","59":"component---src-pages-success-stories-yolcu-360-js","60":"component---src-pages-terms-of-use-js","61":"component---src-pages-ui-ux-design-js","62":"component---src-pages-web-development-js","63":"component---src-pages-whatsapp-marketing-js","64":"component---src-templates-blog-detail-js"}[chunkId]||chunkId) + "-" + {"0":"adfb37d9ff3c84f521a1","1":"29147cbc04bbc833f6a0","2":"37c634bbf86346d50630","3":"1ecc2a932b00bc74829d","4":"a1efe95f54f598fc2359","5":"66b8ff81be0440333e35","8":"9caf21147792762b604a","9":"771653e7217903da650c","10":"60f10cf00e88b3609438","11":"e50c18b3c91317e6df17","12":"0bc239c8902dd5a3e519","13":"46e0f796ed62ef981a69","14":"d141c04d9f5bd442dcc2","15":"7119c13d3df9d0c51ed0","16":"a9f8c2ef332549546b27","17":"2dea65959609f21bfae4","18":"b6e5dd5c3d817b7e9362","19":"c703a16a06bce5f00365","20":"2b23c36bdc47522dc381","21":"79adf8dd61e4294eb4b7","22":"5bbb28741804ba7955ca","23":"3eedec0fd25fa579a1c2","24":"52179b1c8d7cec0b9bb4","25":"9be9033a09d23cbe3d6d","26":"ac467e31546b9dd543ee","27":"33e3812f476147ac68b6","28":"d417b4176a5b4c2293e2","29":"115f94ed5748b74c3a71","30":"5295cdc7dbcd88e85153","31":"4ee38c85675fe685f645","32":"0e10c48cb308f4ef0180","33":"32404558f1d7ebf9d186","34":"859777d4a54dcfd6fbf2","35":"b9dc4810feb65089b2cb","36":"12adc5fac14d768b1bd7","37":"f7ed9e36fdb6be4c6fa5","38":"def1177b6ceb52f08820","39":"f1a19c3827b1646d8150","40":"ad9692a4135fc78d873e","41":"96e066ed18db407610fa","42":"fc27e1cc620897a58da7","43":"8c19419fc12f8b47dfba","44":"c8f4f5ae8db36bdd9ec1","45":"1084f2142efdee6820ae","46":"bea4ee1dc3a8509b70e9","47":"a040027ef4397928dd09","48":"9d429c4c5eeed621dec8","49":"2cbe1cb7a9e187e4f097","50":"31744077a525cb70062f","51":"d4545de78e954592dae0","52":"dc45541fdfb148465a55","53":"0e1e4ef3d175b4efe3e3","54":"14b9028ff3ae4f43d9b6","55":"96b971fb3adb2fc82a36","56":"8e0982f3e44554671947","57":"1b8b577b965d4011f0b1","58":"8f781ec9e9b3eb0b17de","59":"99d939006a832fd9faea","60":"854ae892a33cdfef0886","61":"b37f94c82dba27e9980e","62":"a2dda0f87c472d385ad5","63":"70876cabf3817ce21677","64":"a6b13796543fb905be54"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"3eb8c39f2ff51f0bcc69d995e828fc48bdc07e16","3":"99cb246920e0191a14a9f169705ee41e2ff61333","4":"6507bc04b12a8d75d910d4fa69105b533fedf2fe","5":"fd05bef4642b45e607f5afa7a046c65a4d4a88aa","8":"component---src-pages-404-js","9":"component---src-pages-about-js","10":"component---src-pages-acquisition-js","11":"component---src-pages-ai-agent-consulting-js","12":"component---src-pages-ai-consulting-js","13":"component---src-pages-ai-studio-js","14":"component---src-pages-analysis-js","15":"component---src-pages-ar-filter-js","16":"component---src-pages-blog-js","17":"component---src-pages-brands-js","18":"component---src-pages-contact-js","19":"component---src-pages-content-marketing-js","20":"component---src-pages-conversion-js","21":"component---src-pages-digital-ads-js","22":"component---src-pages-digital-marketing-consultancy-js","23":"component---src-pages-email-marketing-js","24":"component---src-pages-flatart-lab-js","25":"component---src-pages-geo-js","26":"component---src-pages-index-js","27":"component---src-pages-kariyer-js","28":"component---src-pages-landing-builder-js","29":"component---src-pages-privacy-policy-js","30":"component---src-pages-production-service-js","31":"component---src-pages-search-engine-optimization-js","32":"component---src-pages-services-js","33":"component---src-pages-social-media-js","34":"component---src-pages-start-project-js","35":"component---src-pages-success-stories-arcadium-js","36":"component---src-pages-success-stories-cam-hotel-js","37":"component---src-pages-success-stories-ecanta-js","38":"component---src-pages-success-stories-enerjisa-js","39":"component---src-pages-success-stories-forecr-js","40":"component---src-pages-success-stories-fullamoda-js","41":"component---src-pages-success-stories-index-js","42":"component---src-pages-success-stories-kentpark-js","43":"component---src-pages-success-stories-kuruyemis-borsasi-js","44":"component---src-pages-success-stories-liva-pastacilik-case-study-js","45":"component---src-pages-success-stories-liva-pastacilik-js","46":"component---src-pages-success-stories-matbuu-js","47":"component---src-pages-success-stories-milli-piyango-js","48":"component---src-pages-success-stories-mocaco-js","49":"component---src-pages-success-stories-pakmaya-js","50":"component---src-pages-success-stories-pinduk-js","51":"component---src-pages-success-stories-robesnmore-js","52":"component---src-pages-success-stories-sefa-stone-js","53":"component---src-pages-success-stories-stm-js","54":"component---src-pages-success-stories-tanoto-js","55":"component---src-pages-success-stories-tcdd-tasimacilik-js","56":"component---src-pages-success-stories-toyota-js","57":"component---src-pages-success-stories-un-women-js","58":"component---src-pages-success-stories-villa-yapi-js","59":"component---src-pages-success-stories-yolcu-360-js","60":"component---src-pages-terms-of-use-js","61":"component---src-pages-ui-ux-design-js","62":"component---src-pages-web-development-js","63":"component---src-pages-whatsapp-marketing-js","64":"component---src-templates-blog-detail-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"3b2271fbf7d06a29b1b0","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
